import { render, staticRenderFns } from "./FolderItemList.vue?vue&type=template&id=cfa950c4&scoped=true&"
import script from "./FolderItemList.vue?vue&type=script&lang=js&"
export * from "./FolderItemList.vue?vue&type=script&lang=js&"
import style0 from "./FolderItemList.vue?vue&type=style&index=0&id=cfa950c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa950c4",
  null
  
)

export default component.exports